import React from 'react';

import { StyledAction, StyledLink, StyledContainer } from './styles';
import { useHeaderContext } from '../../HeaderContextProvider';
import { NavigationMenuType } from '../../types';
import { PersonIcon } from '../../assets/PersonIcon';
import { ExitAppIcon } from '../../assets/ExitAppIcon';

const NavigationMenu = () => {
  const { useLogout, t, programUrl, colorsPaletteFromBO, routes } =
    useHeaderContext();

  const logout = useLogout();

  const navigationMenus: NavigationMenuType[] = [
    {
      id: 'account',
      label: t('menu.account'),
      type: 'link',
      link: `${programUrl}${routes.STORE_ACCOUNT}`,
      Icon: <PersonIcon color={colorsPaletteFromBO.main} size={'25'} />,
    },
    {
      id: 'logout',
      label: t('auth.logout'),
      type: 'action',
      action: logout,
      Icon: <ExitAppIcon color={colorsPaletteFromBO.main} size={'30'} />,
    },
  ];

  return (
    <StyledContainer>
      {navigationMenus.map(
        ({ id, label, type, action, link, Icon }: NavigationMenuType) => {
          switch (type) {
            case 'action':
              return (
                <StyledAction key={id} onClick={action}>
                  <div>{Icon}</div>
                  <div>{label}</div>
                </StyledAction>
              );

            case 'link':
              return (
                <StyledLink href={link || ''} key={id}>
                  <div>{Icon}</div>
                  <div>{label}</div>
                </StyledLink>
              );
            default:
              return null;
          }
        },
      )}
    </StyledContainer>
  );
};

export default NavigationMenu;
